module.exports = __webpack_public_path__ + "static/media/2.bef6fa6c.jpeg";